import crudAction from './actions'

export default {
  name: 'markets',
  namespace: 'markets',
  methods: [
    ...crudAction,
  ]
}
